import React from "react";
import GoogleSignup from "../component/GoogleSignup";
import { useLocation, useNavigate } from "react-router-dom";
import {
  googleSignUpService,
  postUserSignUpService,
} from "../services/SignUpService";
import { Apinames } from "../utils/Apiname";

type Props = {};

const GoogleSignupScreen = (props: Props) => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const onSignUpPressed = async (signupData: any) => {
    let data = {
      idToken: state.idToken,
      name: signupData.name,
      number: signupData.number,
      address: signupData.address,
      company: signupData.companyName,
      vatNumber: signupData.vatNumber,
    };
    let response = await googleSignUpService(Apinames.usersGoogleSignup, data);
    if (response.result && response.result.toLowerCase() === "success") {
      navigate("/login");
    }
  };
  return <GoogleSignup onSignUpPressed={onSignUpPressed} />;
};

export default GoogleSignupScreen;
